import classNames from "classnames";
import { useEffect, useState, type FunctionComponent } from "react";

import style from "./CountryFlag.module.scss";

const getFlagSvg = async (countryCode: string): Promise<string> => {
  try {
    return (
      await import(
        `nvent-web/assets/svg/country-flags/${countryCode.toLowerCase()}.svg`
      )
    ).default;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (_error) {
    return "";
  }
};

export const CountryFlag: FunctionComponent<{
  countryCode: string;
  className?: string;
}> = ({ countryCode, className = "" }) => {
  const [path, setPath] = useState<string>("");

  useEffect(() => {
    (async () => {
      const path = await getFlagSvg(countryCode);
      setPath(path);
    })();
  }, [countryCode]);

  if (!path) {
    return null;
  }

  return (
    <img
      src={path}
      alt={countryCode}
      className={classNames(style.flag, className)}
    />
  );
};
